import React from 'react';
import { Form, Input } from 'antd';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { LoginFormData } from './types';
import {
  FormItem,
  LinkText,
  ButtonWrapper,
  PrimaryButton,
  PasswordInputWrapper,
  ResponsiveFormWrapper,
  ForgotPasswordLink,
} from '../styles';

interface LoginFormProps {
  control: Control<LoginFormData, any>;
  errors: FieldErrors<LoginFormData>;
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isLoggingIn: boolean;
  hostname: string;
  onForgotPasswordClick: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  control,
  errors,
  onSubmit,
  isLoggingIn,
  hostname,
  onForgotPasswordClick,
}) => {
  return (
    <>
      <ResponsiveFormWrapper>
        <Form layout="vertical" onFinish={onSubmit} size="large">
        <FormItem>
        <Form.Item
          label="Email or Username"
          validateStatus={errors.emailOrUsername ? 'error' : ''}
          help={errors.emailOrUsername?.message}
          required
        >
          <Controller
            name="emailOrUsername"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                placeholder="Enter your email/username here"
              />
            )}
          />
        </Form.Item>
      </FormItem>

      <FormItem>
        <Form.Item
          label="Password"
          validateStatus={errors.password ? 'error' : ''}
          help={errors.password?.message}
          required
        >
          <PasswordInputWrapper>
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <Input.Password
                  {...field}
                  placeholder="Password"
                  iconRender={(visible) => (
                    <FontAwesomeIcon icon={visible ? faEyeSlash : faEye} />
                  )}
                />
              )}
            />
          </PasswordInputWrapper>
        </Form.Item>
      </FormItem>

      {!hostname.includes('admin') && (
        <LinkText>
          <ForgotPasswordLink onClick={onForgotPasswordClick}>
            Forgot Password?
          </ForgotPasswordLink>
        </LinkText>
      )}

      <ButtonWrapper>
        <PrimaryButton
          type="primary"
          htmlType="submit"
          block
          loading={isLoggingIn}
          disabled={isLoggingIn}
        >
          Login
        </PrimaryButton>
      </ButtonWrapper>
      </Form>
      </ResponsiveFormWrapper>
    </>
  );
};

export default LoginForm;
